import { Injectable } from '@angular/core';
import { SupabaseClient, createClient } from '@supabase/supabase-js';
import { environment } from '../environments/environment.generated';

const DEFAULT_DB_TIMEOUT_MS = 25000;
const noOpAuthLock = async <T>(
  _name: string,
  _acquireTimeout: number,
  fn: () => Promise<T>
): Promise<T> => fn();

@Injectable({
  providedIn: 'root'
})
export class SupabaseService {
  public readonly client: SupabaseClient;
  public readonly supabaseUrl: string;
  public readonly supabaseKey: string;

  constructor() {
    const normalizeEnv = (value: string | undefined): string =>
      (value ?? '').trim().replace(/^['"]|['"]$/g, '');

    const importMetaEnv = ((import.meta as any)?.env ?? {}) as Record<string, string | undefined>;
    const processEnv = (((globalThis as any)?.process?.env) ?? {}) as Record<string, string | undefined>;
    const runtimeEnv = { ...environment, ...processEnv, ...importMetaEnv } as Record<string, string | undefined>;

    this.supabaseUrl = normalizeEnv(runtimeEnv.SUPABASE_URL ?? runtimeEnv.PROJETO_URL ?? runtimeEnv.NG_APP_SUPABASE_URL ?? '');
    this.supabaseKey = normalizeEnv(runtimeEnv.SUPABASE_ANON_KEY ?? runtimeEnv.ANON_KEY ?? runtimeEnv.NG_APP_SUPABASE_ANON_KEY ?? '');

    if (!this.supabaseUrl || !this.supabaseKey) {
      throw new Error('Supabase env ausente. Preencha SUPABASE_URL/PROJETO_URL e SUPABASE_ANON_KEY/ANON_KEY em .env.local.');
    }
    
    this.client = createClient(this.supabaseUrl, this.supabaseKey, {
      db: {
        timeout: DEFAULT_DB_TIMEOUT_MS,
      },
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        lock: noOpAuthLock,
      },
    });
  }
}
